export default class IntraAppMessagingService {

  static shareAuthTokenWithMobileApp(authToken) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ authToken: authToken }));
    }
  }

  static shareUnreadNotificationCount(unreadNotificationCount) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ unreadTackNotificationCount: unreadNotificationCount }));
    }
  }

  static notifyLoggedOut() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ loggedOut: true }));
    }
  }

  static tellMobileAppToPopupPaymentOptions() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ popupMobilePaymentOptions: true }));
    }
  }

  static notifyOnSubscriptionPage() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ onSubscriptionPage: true }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/intra_app_messaging_service.js